import { SharedEventModel } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventModel';
import { Observable, Observer, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { share, filter } from 'rxjs/operators';

//More about sharedService: http://stackoverflow.com/a/36174340/3955513
@Injectable({
    providedIn: 'root',
})
export class SharedService {
    subject = new Subject<SharedEventModel>();

    constructor() {}

    broadcast(event: SharedEventModel) {
        this.subject.next(event);
    }

    on(event_name, callback) {
        return this.subject
            .pipe(filter((x) => x.name === event_name))
            .subscribe(callback);
    }
}
